<template>
  <div
    :class="{
      'bg-avtalat-teal': !warningColor,
      'bg-pink-400': warningColor === 'pink',
      'bg-red-600': warningColor === 'red',
    }"
  >
    <ContainerGrid>
      <div
        :class="{
          'col-span-3': true,
          'text-white': true,
          flex: true,
          'flex-row': true,
          'justify-center': true,
          'align-items-center': true,
          'items-center': true,
          'self-stretch': true,
          'py-sm': true,
          relative: true,
        }"
      >
        <slot></slot>
      </div>
    </ContainerGrid>
  </div>
</template>

<script lang="ts" setup>
import { ContainerGrid } from "@/layout";

defineProps<{
  warningColor?: "red" | "pink";
}>();
</script>
